import { Link } from "react-router-dom";
import FilmCard from "@/components/feature/FilmCard";
import { films } from "@/mocks/films";
import type { Film } from "@/types/content";

export default function FeaturedFilms() {
  const featured = (films as Film[]).filter((film) => film.featured);

  return (
    <section className="bg-background-100/60 border-y border-background-200/60">
      <div className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-label tracking-widest text-accent-500 uppercase mb-3">Featured</p>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">精选影片</h2>
          </div>
          <Link
            to="/films"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-label text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2">
          {featured.map((film) => (
            <FilmCard key={film.id} film={film} variant="scroll" />
          ))}
        </div>
      </div>
    </section>
  );
}